function authHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken')
  return token ? { 'Authorization': `Bearer ${token}` } : {}
}

/**
 * Backend API endpoints all live under /api/* so they never collide with
 * SPA routes. Callers pass the logical path (e.g. "/sessions") and we
 * prepend the prefix automatically; absolute URLs are passed through.
 */
function toApiUrl(url: string): string {
  if (/^https?:\/\//i.test(url) || url.startsWith('/api/')) return url
  return '/api' + (url.startsWith('/') ? url : '/' + url)
}

export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const headers = {
    ...authHeaders(),
    ...(options.headers as Record<string, string> || {})
  }
  const response = await fetch(toApiUrl(url), { ...options, headers })

  if (response.status === 401) {
    localStorage.removeItem('authToken')
    window.location.href = '/login'
  }

  return response
}
